
sap["ls"]["preload"]["UCF_MessageBar"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_Page */
/// <reference path="../core/Page.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * A clickable TextView
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_MessageBar(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["UCF_MessageBar"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "MessageBar.js(32): UCF_MessageBar"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "MessageBar.js(33): UCF_MessageBar"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "MessageBar.js(34): UCF_MessageBar"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	this["oHelpLink"] = UCF_DomUtil["$"](this["sId"] + "-help");
	this["allowTextSelection"]();
	this["sClassImagePrefix"] = "urMsgBarImg";
	this["sClassIconPrefix"] = "lsMsgBarIcon";
	this["sClassImageStdPrefix"] = "lsMessageBar__image--";
	this["sClassIconStdPrefix"] = "lsMessageBar__icon--";
	this["sClassTypePrefix"] = "lsMessageBar--type";
	this["bToggleFocusActive"] = false;
};window["UCF_MessageBar"] = UCF_MessageBar; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_MessageBar"); UCF_MessageBar["_"] = {UCF_MessageBar: 0}; }; ;
UCF_MessageBar["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_MessageBar.prototype["sClassName"] = "UCF_MessageBar";

/**
 * Initializes the MessageBar
 */
UCF_MessageBar["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["initialize"]++; }; 

	//empty, just to find the message bar for a certain input field
	if (this["sBindingPath"]) {
		this["initBindings"]();
	}

};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["initialize"] = 0; };

/**
 * Initializes messages that are bound to controls
 */
UCF_MessageBar["prototype"]["initBindings"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["initBindings"]++; }; 
	var sModelId = this["sBindingPath"]["substring"](0, this["sBindingPath"]["indexOf"](">")),
		oPage = this["oLS"]["oGetPageInternal"](),
		oModel = null;
	if (oPage)
		oModel = oPage["getModel"](sModelId);
	if (oModel) {
		var aControls = oModel["getBoundControls"](this["sBindingPath"]);
		for (var i = 0; i < aControls["length"]; i++) {
			var oControl = aControls[i];
			if (oControl["getUCFInstance"] && oControl["getUCFInstance"]()) {
				var oUCFInstance = oControl["getUCFInstance"]();
				if (oUCFInstance) {
					var oText = UCF_DomUtil["$"](this["sId"] + '-txt');
					UCF_JsUtil["delayedCall"](10, oUCFInstance, "createDataTip", [this["sType"], UCF_DomUtil["sGetInnerText"](oText)]);
				}
			}
		}
	} else {
		if (oPage)
			oPage["attachEvent"](oPage["E_EVENTS"]["ModelAvailable"], this, "initBindings");
	}
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["initBindings"] = 0; };
/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageBar["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageBar.js(94): onclick"); };

	var oSource = oBrowserEvent["oGetSource"]();

	if (!this["mEvents"]["Click"]) {
		if ((this["bHasHelpLink"]) && (oSource === this["oHelpLink"])) {
			this["fireActivateHelp"](this["sId"]);
			oBrowserEvent["cancelBubble"]();
		} else {
			this["focusConnectedControl"]();
			oBrowserEvent["cancelBubble"]();
		}
	} else {
		if (this["mEvents"]["ActivateHelp"] && this["bHasHelpLink"] && (oSource === this["oHelpLink"])) {
			this["fireActivateHelp"](this["sId"]);
			oBrowserEvent["cancelBubble"]();
		} else {
			this["fireClick"](this["sId"]);
			oBrowserEvent["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onclick"] = 0; };

/**
 * Handles the ondblclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageBar["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageBar.js(124): ondblclick"); };

	if (!this["mEvents"]["DoubleClick"]) return;

	this["fireDoubleClick"](this["sId"]);
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["ondblclick"] = 0; };
/**
 * Handles selection by keyboard
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageBar["prototype"]["onlsspace"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onlsspace"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageBar.js(139): onlsspace"); };

	this["handleClick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onlsspace"] = 0; };

/**
 * Handles the click on the menu with keyboard or mouse
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageBar["prototype"]["handleClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["handleClick"]++; }; 

	var oSource = oBrowserEvent["oGetSource"]();

	if (this["bHasHelpLink"] && (oSource === this["oHelpLink"])) {
		this["fireActivateHelp"](this["sId"]);
	} else {
		this["focusConnectedControl"]();
	}
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();

};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["handleClick"] = 0; };

/**
 * Handles the onlsselect event of lightspeed
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageBar["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onlsenter"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageBar.js(172): onlsenter"); };

	this["handleClick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onlsenter"] = 0; };

/**
 * Sets the focus to the connected control that corresponds to the message
 * If the connected control cannot receive the focus this function is ignored.
 * @return {boolean} true if the connected control received the focus.
 */
UCF_MessageBar["prototype"]["focusConnectedControl"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["focusConnectedControl"]++; }; 
	if (!this["sConnectedControlId"]) return false;
	var oTargetControl = this["oGetControlById"](this["sConnectedControlId"]);
	if (!oTargetControl) return false;
	// ARIA: put message in aria-describedby of the target control
	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setDescribedby"](oTargetControl["oDomRef"], this["sId"]);
	}
	if (oTargetControl["bIsFocusable"]) {
		oTargetControl["focus"](this["sFocusData"]);
		return true;
	}
	return false;

};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["focusConnectedControl"] = 0; };

/**
 * Highlights the message bar for a short time
 * This effect can be used to highlight the message bar if the corresponding input element got the focus.
 * The effect can only be seen if animations are allowed with UCF_System.bUseAnimation.
 *
 * @private
 */
UCF_MessageBar["prototype"]["highlight"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["highlight"]++; }; 
	//TODO
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["highlight"] = 0; };

/**
 * Set the type of the MessageBar
 *
 * @param {string} sType
 * @public
 */
UCF_MessageBar["prototype"]["setType"] = function(sType) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setType"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sType) === "string", "typeof(sType) === \"string\"", "MessageBar.js(217): setType"); };
	this["setInvalidated"](false);
	var oImg = UCF_DomUtil["$"](this["sId"] + '-img'),
		oIcon = UCF_DomUtil["$"](this["sId"] + '-icon'),
		sTop = this["oDomRef"]["className"]["indexOf"]("Top") > -1 ? "Top" : "",
		sBottom = this["oDomRef"]["className"]["indexOf"]("Btm") > -1 ? "Btm" : "";
	var sOldSuffix = this["sGetTypeSuffix"](this["sType"]),
		sNewSuffix = this["sGetTypeSuffix"](sType),
		sOldImgClassName = this["sClassImagePrefix"] + sOldSuffix,
		sNewImgClassName = this["sClassImagePrefix"] + sNewSuffix,
		sOldIconClassName = this["sClassIconPrefix"] + sOldSuffix,
		sNewIconClassName = this["sClassIconPrefix"] + sNewSuffix,
		sOldImgStdClassName = this["sClassImageStdPrefix"] + sOldSuffix,
		sNewImgStdClassName = this["sClassImageStdPrefix"] + sNewSuffix,
		sOldIconStdClassName = this["sClassIconStdPrefix"] + sOldSuffix,
		sNewIconStdClassName = this["sClassIconStdPrefix"] + sNewSuffix,
		sOldTypeClass = this["sClassTypePrefix"] + sOldSuffix,
		sNewTypeClass = this["sClassTypePrefix"] + sNewSuffix;

	if (this["sRulerDisplay"] === "NONE") {
		UCF_DomUtil["replaceClass"](this["oDomRef"], "urMsgBar" + sOldSuffix, "urMsgBar" + sNewSuffix);
	} else {
		if (this["sType"] !== "ERROR" && sType === "ERROR") {
			UCF_DomUtil["replaceClass"](this["oDomRef"], "urMsgBarStd" + sTop + sBottom, "urMsgBarErr" + sTop + sBottom);
		} else if (this["sType"] === "ERROR" && sType !== "ERROR") {
			UCF_DomUtil["replaceClass"](this["oDomRef"], "urMsgBarErr" + sTop + sBottom, "urMsgBarStd" + sTop + sBottom);
		}
	}

	UCF_DomUtil["replaceClass"](this["oDomRef"], sOldTypeClass, sNewTypeClass);

	this["sType"] = sType;
	if (oImg != null && sOldImgClassName !== sNewImgClassName) {
		UCF_DomUtil["replaceClass"](oImg, sOldImgClassName, sNewImgClassName);

	}
	if (oIcon != null && sOldIconClassName !== sNewIconClassName) {
		UCF_DomUtil["replaceClass"](oIcon, sOldIconClassName, sNewIconClassName);
		if (window["UCF_System"]["sDevice"] === "standards") {
			UCF_DomUtil["replaceClass"](oIcon, sOldIconStdClassName, sNewIconStdClassName);
			UCF_DomUtil["replaceClass"](oIcon, sOldImgStdClassName, sNewImgStdClassName);
		}
	}
	this["setClientProperty"]("Type", this["sType"], true);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setType"] = 0; };

/**
 * @private
 * @param {string} sType
 * @return {string}
 */
UCF_MessageBar["prototype"]["sGetTypeSuffix"] = function(sType) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["sGetTypeSuffix"]++; }; 
	return this["oLS"]["oGetRenderManager"]()["callFragment"](
		'MessageBarTypeSuffixFragment',
		'MessageBar', { "Type": sType }
	);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["sGetTypeSuffix"] = 0; };

/**
 * Set the text of the MessageBar
 *
 * @param {string} sText
 * @public
 */
UCF_MessageBar["prototype"]["setText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setText"]++; }; 
	var oText = UCF_DomUtil["$"](this["sId"] + '-txt');
	this["setInvalidated"](false);
	UCF_DomUtil["setInnerText"](oText, sText);
	this["sText"] = sText;
	this["setClientProperty"]("Text", this["sText"], true);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setText"] = 0; };
/**
 * Sets or removes the message bar invalidated state
 * Use this state in case the corresponding field was changed but not yet confirmed to be corrected
 * @param {boolean} bInvalidated The invalidated state
 */
UCF_MessageBar["prototype"]["setInvalidated"] = function(bInvalidated) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setInvalidated"]++; }; 

	if (window["UCF_System"]["sDevice"] === "standards") return;

	var oText = UCF_DomUtil["$"](this["sId"] + '-txt'),
		oImg = UCF_DomUtil["$"](this["sId"] + '-img');
	if (bInvalidated) {
		oText["style"]["color"] = "#999";
		this["oDomRef"]["style"]["borderColor"] = "#999";
		if (oImg)
			UCF_DomUtil["setOpacityStyle"](oImg, 30);
	} else {
		this["oDomRef"]["style"]["borderColor"] = "";
		oText["style"]["color"] = "";
		oText["style"]["textDecoration"] = "";
		if (oImg)
			UCF_DomUtil["setOpacityStyle"](oImg, 100);
	}
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setInvalidated"] = 0; };

/**
 * Handles the mouseover event on the label
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageBar["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageBar.js(320): onmouseover"); };

	if (window["UCF_System"]["bIs508"] || this["bWrapping"] || !this["bTextOverflow"]) return;
	// the text will not be added to the Title when Wrapping=true and the
	// Label is into container which has Overflow
	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oSource = oBrowserEvent["oGetSource"](),
		oMessageBarText = UCF_DomUtil["$"](this["sId"] + "-txt");

	if (oSource !== oMessageBarText) return;

	var oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + "-txt");
	if (oDomRefOvfl) {
		UCF_DomUtil["checkTooltip"](this["oDomRef"], this["sTooltip"], oDomRefOvfl);
	}

};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onmouseover"] = 0; };

/**
 * Writes the appropriate acc text into the tooltip
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageBar["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageBar.js(346): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oSource = oBrowserEvent["oGetSource"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		oHelpLink = UCF_DomUtil["$"](this["sId"] + "-help");

	if (oSource === oHelpLink) {
		oAccessibilityHelper["setControlType"]("LN");
		if (this["sHelpLinkText"] !== '')
			oAccessibilityHelper["setText"](this["sHelpLinkText"]);
		else
			oAccessibilityHelper["addTutor"]("HELP");
		oAccessibilityHelper["addTutor"]("LN_TUT");
		if (this["bToggleFocusActive"]) {
			oAccessibilityHelper["addTutor"]("MA_TOGGLE_FOCUS");
		}
	} else {
		if (this["sType"] === "ERROR")
			oAccessibilityHelper["addTutor"]("ERROR");
		else if (this["sType"] === "OK")
			oAccessibilityHelper["addTutor"]("SUCCESS");
		else if (this["sType"] === "STOP")
			oAccessibilityHelper["addTutor"]("STOP");
		else if (this["sType"] === "WARNING")
			oAccessibilityHelper["addTutor"]("WARNING");
		else if (this["sType"] === "LOADING")
			oAccessibilityHelper["addTutor"]("LOADING");
		else if (this["sType"] === "INFO")
			oAccessibilityHelper["addTutor"]("INFO");
		else if (this["sType"] === "NOTIFICATION")
			oAccessibilityHelper["addTutor"]("NOTIFICATION");
		else if (this["sType"] === "ALERT")
			oAccessibilityHelper["addTutor"]("ALERT");
		else if (this["sType"] === "TASK")
			oAccessibilityHelper["addTutor"]("TASK");
		oAccessibilityHelper["setText"](this["sText"]);
		if (this["sText"] !== this["sTooltip"])
			oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	}

};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onlsaccessibility"] = 0; };
/**
 * Notifies Message Area, that focus toggle feature is active (to add tutor text)
 *
 * @param {boolean} bActive  Focus toggle is active/inactive
 * @public
 */
UCF_MessageBar["prototype"]["notifyMessageFocusToggleActive"] = function(bActive) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["notifyMessageFocusToggleActive"]++; }; 
	this["bToggleFocusActive"] = bActive;
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["notifyMessageFocusToggleActive"] = 0; };

/**
 * See UCF_Control.aGetTouchContextMenuEntries()
 * @private
 * @return {Array<{sType: ('TOOLTIP'|'TEXT'|'DATATIP'|'DOUBLECLICK'|'QUICKVIEW'), sText: string, fTrigger: function(): void}>}
 */
UCF_MessageBar["prototype"]["aGetTouchContextMenuEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["aGetTouchContextMenuEntries"]++; }; 
	var aResult = UCF_Control.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);
	if (this["bTextOverflow"]) {
		var oTextDomRef = UCF_DomUtil["$"](this["sId"] + '-txt');
		if (oTextDomRef && UCF_DomUtil["bHasTextEllipsis"](this["oDomRef"], oTextDomRef)) {
			aResult["push"]({
				"sType": 'TEXT',
				"sText": UCF_DomUtil["removeColon"](UCF_DomUtil["sGetInnerText"](oTextDomRef))
			});
		}
	}
	return aResult;
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["aGetTouchContextMenuEntries"] = 0; };

UCF_MessageBar["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["destroy"]++; }; 

	this["oHelpLink"] = null;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sText"] = null;
	this["bToggleFocusActive"] = false;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sType"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_MessageBar["prototype"]["aAttributeNames"] = ["sText","sType","sRulerDisplay","sVisibility","sConnectedControlId","sTooltip","bHasHelpLink","sHelpLinkText","sFocusData","sCustomStyle","sBindingPath","sCustomData","bWrapping","bTextOverflow"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_MessageBar["prototype"]["aEventNames"] = ["DoubleClick","Click","ActivateHelp"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_MessageBar["prototype"]["aMethodNames"] = ["setText","setType","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sText"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.MessageType}
 */
UCF_MessageBar["prototype"]["sType"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.MessageBarRulerDisplay}
 */
UCF_MessageBar["prototype"]["sRulerDisplay"] = "BOTTOM";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_MessageBar["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sConnectedControlId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_MessageBar["prototype"]["bHasHelpLink"] = false;

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sHelpLinkText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sFocusData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sBindingPath"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_MessageBar["prototype"]["bWrapping"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_MessageBar["prototype"]["bTextOverflow"] = false;

//#JSCOVER_EXCL_START
/** @protected */
UCF_MessageBar["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setDefaultValues"]++; }; 
	this["sText"] = '';
	this["sType"] = "NONE";
	this["sRulerDisplay"] = "BOTTOM";
	this["sVisibility"] = "VISIBLE";
	this["sConnectedControlId"] = '';
	this["sTooltip"] = '';
	this["bHasHelpLink"] = false;
	this["sHelpLinkText"] = '';
	this["sFocusData"] = '';
	this["sCustomStyle"] = '';
	this["sBindingPath"] = '';
	this["sCustomData"] = '';
	this["bWrapping"] = true;
	this["bTextOverflow"] = false;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Type", "NONE", true);
		this["setClientProperty"]("RulerDisplay", "BOTTOM", true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("ConnectedControlId", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("HasHelpLink", false, true);
		this["setClientProperty"]("HelpLinkText", '', true);
		this["setClientProperty"]("FocusData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("BindingPath", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("Wrapping", true, true);
		this["setClientProperty"]("TextOverflow", false, true);
	}
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the Button control.
 * @fires MessageBar::DoubleClick
 */
UCF_MessageBar["prototype"]["fireDoubleClick"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "MessageBar.js(581): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MessageBar.js(582): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MessageBar.js(583): fireDoubleClick"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("MessageBar", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["fireDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the Button control.
 * @fires MessageBar::Click
 */
UCF_MessageBar["prototype"]["fireClick"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["fireClick"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "MessageBar.js(600): fireClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MessageBar.js(601): fireClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MessageBar.js(602): fireClick"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("MessageBar", "Click", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["fireClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires MessageBar::ActivateHelp
 */
UCF_MessageBar["prototype"]["fireActivateHelp"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["fireActivateHelp"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "MessageBar.js(619): fireActivateHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MessageBar.js(620): fireActivateHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MessageBar.js(621): fireActivateHelp"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("MessageBar", "ActivateHelp", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["fireActivateHelp"] = 0; };

UCF_MessageBar.prototype["aPublicMethods"] = ["setType","setText","notifyMessageFocusToggleActive"].concat(UCF_MessageBar.prototype.aPublicMethods || []);
};